module.exports = __webpack_public_path__ + "669d39c.woff2";